<script setup lang="ts">
import {shorten} from "@/modules/Utilities";

const props = defineProps<{
    review: {
        title: string,
        text: string,
        author: string,
        source: string,
        stars: number,
        link: string
    }
}>()

</script>

<template>
    <article class="review-card flex flex-column">
        <div>
            <h3 class="review-card-title">{{ props.review.title }}</h3>
        </div>
        <div class="review-card-stars">
            <span v-for="x in props.review.stars" :key="x" class="icon-star-full" aria-hidden="true"></span>
            <span class="sr-only">{{ props.review.stars }} out of 5 stars</span>
        </div>
        <div class="flex-grow-1 review-card-body">
            <p>{{ shorten(review.text, 230) }}</p>
        </div>
        <div class="review-card-meta">
            <span>—{{ review.author }} at</span>
            <a :href="review.link" target="_blank" rel="noopener noreferrer">{{ review.source }}</a>
        </div>
    </article>
</template>

<style scoped>
.review-card {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(246, 249, 255, 0.96));
    border: 1px solid rgba(58, 123, 213, 0.2);
    border-radius: 0.9rem;
    box-shadow: 0 10px 24px -22px rgba(20, 35, 70, 0.8);
    padding: 1.1rem;
}

.review-card-title {
    font-size: clamp(1.2rem, 2vw, 1.6rem);
    line-height: 1.1;
    margin: 0;
}

.review-card-stars {
    display: flex;
    gap: 0.2rem;
    margin-top: 0.55rem;
}

.icon-star-full {
    color: #ffd700;
}

.sr-only {
    clip: rect(0, 0, 0, 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.review-card-body p {
    margin: 0.85rem 0 0;
}

.review-card-meta {
    align-items: center;
    color: var(--brand-muted-text);
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    margin-top: 1rem;
}
</style>
